




































































import { Component, Vue, Watch } from 'vue-property-decorator';
import List from './list.vue';
import Detail from './detail.vue';
import Share from '@/components/shares/index.vue';
import homeFooter from '@/views/home/component/footer.vue';
import { Action } from 'vuex-class';
@Component({
  components: { List, Detail, homeFooter, Share },
})
export default class Programme extends Vue {
  @Action('question/saveSearch') private saveSearch: any;
  private info: any = [];
  private infoDetail: any = [];
  private articleTypeId: any = null;
  private page: any = this.$route.query.page || 1;
  private pageSize: any = 10;
  private total: any = 0;

  private totalPage: any = 0;
  private articleData: any = [];
  private searchValue: any = this.$route.query.name || null;
  private articlId: any = this.$route.query.id;
  private voteRecommendList: any = [
    // {
    //   recommendImgUrl:
    //     "https://image.longyixiu.com/7d37928285ea423c82a43cb2d38f0cd3",
    //   voteName: "圣诞节",
    //   voteId: 2628,
    // },
  ]; // 推荐模板
  private articleHotList: any = []; // 精选活动方案
  private isDetail: any = false; // 是否是详情页
  private articleDetail: any = null; // 详情页内容
  private isFixed: any = false;
  private offsetTop: any = 0;
  private articleCount: any = {
    voteCount: 0,
    questionCount: 0,
    luckDrawCount: 0,
  };
  private shareTopic: any = [
    { name: '投票评选方案', id: 6 },
    { name: '问卷调查方案', id: 7 },
    { name: '考试测评方案', id: 13 },
    { name: '报名表单方案', id: 14 },
    { name: '在线接龙方案', id: 15 },
    { name: '在线收款方案', id: 16 },
    { name: '在线预约方案', id: 18 },
    { name: 'H5制作方案', id: 19 },
    { name: '海报设计方案', id: 20 },
  ];
  private tabList: any = [
    { name: '投票评选方案', id: 6, icon: 'programme_icon_1', eng: 'voting' },
    {
      name: '问卷调查方案',
      id: 7,
      icon: 'programme_icon_2',
      eng: 'questionnaire',
    },
    { name: '考试测评方案', id: 13, icon: 'programme_icon_3', eng: 'exam' },
    { name: '报名表单方案', id: 14, icon: 'programme_icon_4', eng: 'form' },
    {
      name: '在线接龙方案',
      id: 15,
      icon: 'programme_icon_5',
      eng: 'solitaire',
    },
    { name: '在线收款方案', id: 16, icon: 'programme_icon_6', eng: 'online' },
    { name: '在线预约方案', id: 18, icon: 'programme_icon_6', eng: 'appoint' },
    { name: 'H5制作方案', id: 19, icon: 'programme_icon_7', eng: 'h5' },
    { name: '海报设计方案', id: 20, icon: 'programme_icon_8', eng: 'poster' },
  ];
  private mounted() {
    window.addEventListener('scroll', this.initHeight);
    this.$nextTick(() => {
      const el: any = document.querySelector('.elaborate');
      this.offsetTop = el.offsetTop;
    });
  }
  private created() {
    console.log(this.$route.query.type, 'this.$route.query.type');
    if (this.$route.query.type) {
      this.articleTypeId = Number(this.$route.query.type);
    }
    const pType: any = this.$route.query.pType;
    let articleTypeName: any = '';
    if (pType) {
      this.articleTypeId = this.tabList.filter((ele: any) => ele.eng === pType)[0].id;
      articleTypeName = this.tabList.filter((ele: any) => ele.eng === pType)[0].name;
    }
    document.title = `活动方案_${articleTypeName || '投票评选方案'}_${this.$globalName}`;

    this.getVoteRecommendList();
    this.getArticleCount();
    this.getArticleHotList();
    if (this.articlId) {
      this.isDetail = true;
      this.getArticleDetail();
    }
  }
  private initHeight() {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
    this.isFixed = scrollTop > this.offsetTop ? true : false;
  }
  private destroyed() {
    // window.removeEventListener("scroll", this.handleScroll);
  }
  private search() {
    this.saveSearch({ searchName: this.searchValue, searchSource: 3 });
    const typeList: any = this.tabList.filter((el: any) => el.id === this.articleTypeId);
    this.$router.push({
      path: '/programme/index.html',
      query: {
        pType: typeList.length > 0 ? typeList[0].eng : null,
        page: '1',
        name: this.searchValue || undefined,
      },
    });
    // setTimeout(() => {
    //   var el: any = this.$refs.programme;
    //   if (el) {
    //     el.articleData = [];
    //     el.totalPage = 0;
    //     el.total = 0;
    //     el.page = 1;
    //     el.keyword = this.searchValue;
    //     el.getArticleList();
    //   }
    // }, 0);
  }
  private handleTab(idx: any, index: any) {
    this.$router.push({
      path: '/programme/index.html',
      query: {
        pType: this.tabList[index].eng,
        page: '1',
        name: this.searchValue || undefined,
      },
    });
    // this.articleTypeId = idx;
    // this.articlId = null;y
    // this.isDetail = false;
    // setTimeout(() => {
    //   var el: any = this.$refs.programme;
    //   if (el) {
    //     el.articleData = [];
    //     el.totalPage = 0;
    //     el.total = 0;
    //     el.page = 1;
    //     el.keyword = this.searchValue;
    //     el.getArticleList();
    //   }
    // }, 0);
    // console.log(idx);
    // document.title = "活动方案_" + this.tabList[index].name + "_" + this.$globalName;
  }
  /**
   * 跳转活动详情
   */
  private getVoteDetail(item: any, caseType: any) {
    console.log(this.articleTypeId);
    if (this.articleTypeId === 6 || !this.articleTypeId) {
      let voteId = item.voteId;
      if (voteId) {
        voteId = this.$tool.encrypt(item.voteId);
      }
      const { href } = this.$router.resolve({
        name: 'voteDetail',
        query: {
          voteId,
          caseType,
        },
      });

      window.open(href, '_blank');
    } else {
      console.log(item);
      let questionId = item.questionId;
      if (questionId) {
        questionId = this.$tool.encrypt(item.questionId);
      }
      const { href } = this.$router.resolve({
        name: 'questionDetail',
        query: {
          questionId,
          caseType,
        },
      });

      window.open(href, '_blank');
    }
  }
  // 跳转到详情页
  private toDetail(item: any) {
    // console.log(item);
    if (item) {
      this.articlId = item.id;
      this.isDetail = true;
      this.articleDetail = item;
    }
  }
  /**
   * 文章列表数据
   */
  private async getArticleDetail() {
    let detail: any = null;
    if (this.articlId) {
      detail = await this.$apis.getArticleDetail({
        id: this.articlId,
      });

      if (detail && detail !== null) {
        this.articleDetail = detail;
        // console.log(this.articleDetail, "title");
        document.title = this.articleDetail.title + '_' + this.$globalName;
      }
    }
  }
  /**
   * 推荐模板
   */
  private async getVoteRecommendList() {
    console.log(this.articleTypeId, 'this.articleTypeId');
    this.voteRecommendList = await this.$apis.getVoteRecommendList({
      page: 1,
      pageSize: 5,
      articleTypeId: this.articleTypeId,
    });

    this.voteRecommendList = this.voteRecommendList.data;
    console.log(this.voteRecommendList);
  }
  /**
   * 精选活动方案
   */
  private async getArticleHotList() {
    this.articleHotList = await this.$apis.getArticleHotList({
      page: 1,
      pageSize: 5,
      systemType: 2,
      articleTypeId: this.articleTypeId,
    });

    this.articleHotList = this.articleHotList.data;
    // console.log(this.articleHotList);
  }

  /**
   * 活动方案分类个数
   */
  private async getArticleCount() {
    this.articleCount = await this.$apis.getArticleCount({});
    console.log(this.articleCount);
  }
}
